// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1lNnO","header":"MessagesList_header__2TNfS","chat":"MessagesList_chat__3OrUt"};